module.exports = __webpack_public_path__ + "img/alearn_render1_thumb.60e245f3.jpg";